"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKpiPopLabel = void 0;
var sdk_model_1 = require("@gooddata/sdk-model");
var getGeneralKpiPopLabel = function (intl) {
    return intl.formatMessage({ id: "filters.allTime.previousPeriod" });
};
var getRelativeFilterKpiPopLabel = function (filter, intl) {
    var _a = sdk_model_1.relativeDateFilterValues(filter), from = _a.from, to = _a.to, granularity = _a.granularity;
    var n = Math.abs(to - from) + 1;
    switch (granularity) {
        case "GDC.time.minute":
            return intl.formatMessage({ id: "filters.minute.previousPeriod" }, { n: n });
        case "GDC.time.hour":
            return intl.formatMessage({ id: "filters.hour.previousPeriod" }, { n: n });
        case "GDC.time.date":
            return intl.formatMessage({ id: "filters.day.previousPeriod" }, { n: n });
        case "GDC.time.week_us":
            return intl.formatMessage({ id: "filters.week.previousPeriod" }, { n: n });
        case "GDC.time.month":
            return intl.formatMessage({ id: "filters.month.previousPeriod" }, { n: n });
        case "GDC.time.quarter":
            return intl.formatMessage({ id: "filters.quarter.previousPeriod" }, { n: n });
        case "GDC.time.year":
            return intl.formatMessage({ id: "filters.year.previousPeriod" }, { n: n });
        default:
            return "";
    }
};
exports.getKpiPopLabel = function (filter, comparisonType, intl) {
    if (comparisonType === "lastYear") {
        // This string is meant to be the same no matter the filter
        return intl.formatMessage({ id: "filters.allTime.lastYear" });
    }
    if (sdk_model_1.isRelativeDateFilter(filter) && !sdk_model_1.isAllTimeDateFilter(filter)) {
        return getRelativeFilterKpiPopLabel(filter, intl);
    }
    return getGeneralKpiPopLabel(intl);
};
//# sourceMappingURL=translations.js.map